import { render } from "./AppModal.vue?vue&type=template&id=3c8a7d7a&scoped=true&lang=pug"
import script from "./AppModal.vue?vue&type=script&lang=ts"
export * from "./AppModal.vue?vue&type=script&lang=ts"

import "./AppModal.vue?vue&type=style&index=0&id=3c8a7d7a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c8a7d7a"

export default script